import { UserCircleIcon } from "@heroicons/react/24/outline";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppPersonIcon = (props: Props) => {
  const { className, ...rest } = props;

  return <UserCircleIcon {...rest} className={props.className} />;
};
export default withIconSize(AppPersonIcon);
